<!-- 统计项 -->
<template>
  <div class="statistical-item">
    <!-- 标题 -->
    <div class="">{{ title }}</div>
    <!-- 今日数据 -->
    <div>
      <span class="text-xl text-bold">{{ today }}</span>
    </div>
    <!-- 环比数据数据 -->
    <div>
      <span class="statistical-item-title">较昨日：</span>
      <span v-if="compareYesterday > 0" class="text-red">上升 {{ compareYesterday }}</span>
      <span v-else-if="compareYesterday < 0" class="text-green">下降 {{ compareYesterday }}</span>
      <span v-else>持平</span>
    </div>
    <!-- 总数据数据 -->
    <div v-if="showHistory">
      <span class="statistical-item-title">历史总数：</span>
      <span>{{ history }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatisticalItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    today: {
      type: Number,
      default: 0
    },
    yesterday: {
      type: Number,
      default: 0
    },
    history: {
      type: Number,
      default: 0
    },
    // 是否需要显示历史总数
    showHistory: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    compareYesterday() {
      // 1. 步骤一：转为合法数字，避免非数字干扰
      const today = Number(this.today) || 0;
      const yesterday = Number(this.yesterday) || 0;

      // 2. 步骤二：消除浮点数精度问题（核心：转整数运算）
      const multiplier = 100;
      const todayInt = Math.round(today * multiplier);
      const yesterdayInt = Math.round(yesterday * multiplier);
      const diffInt = todayInt - yesterdayInt;
      const diff = diffInt / multiplier;

      // 3. 步骤三：四舍五入保留2位小数，再自动去除末尾无效 0
      // 逻辑：toFixed(2) 实现四舍五入 → Number() 自动去末尾 0
      const result = Number(diff.toFixed(2));

      return result;
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
  .statistical-item {
    border-radius: 10px;
    padding: 10px;
    text-align: left;
    background-color: #f0f0f0;
    .statistical-item-title {
      color: #999;
    }
  }
</style>
